import { render, staticRenderFns } from "./UserProperty.vue?vue&type=template&id=c51d9fd0&scoped=true&"
import script from "./UserProperty.vue?vue&type=script&lang=js&"
export * from "./UserProperty.vue?vue&type=script&lang=js&"
import style0 from "./UserProperty.vue?vue&type=style&index=0&id=c51d9fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51d9fd0",
  null
  
)

export default component.exports